import { render, staticRenderFns } from "./ProfileContractTable.vue?vue&type=template&id=1898289a&scoped=true&"
import script from "./ProfileContractTable.vue?vue&type=script&lang=js&"
export * from "./ProfileContractTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1898289a",
  null
  
)

export default component.exports